import React, { Component, createContext } from "react";

const LocaleContext = createContext();
const { Provider, Consumer: LocaleConsumer } = LocaleContext;

class LocaleProvider extends Component {
  // loacle 기본값은 kr
  state = {
    locale: "kr"
  };

  // 변화를 일으키는 함수를 전달할 때 actions 객체 하나로 한꺼번에 전달
  actions = {
    setValue: lang => {
      this.setState({ locale: lang });
    }
  };

  render() {
    const { state, actions } = this;
    const locale = { state, actions };

    return <Provider value={locale}>{this.props.children}</Provider>;
  }
}

export { LocaleProvider, LocaleConsumer };
